
document.addEventListener('DOMContentLoaded', naja.initialize.bind(naja));
